import { React, useState, useEffect, useContext } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";

import { Model, StylesManager } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/modern.css";
import * as widgets from "surveyjs-widgets";
import { Link, useHistory, useParams } from "react-router-dom";
import "survey-react/modern.css";
import db from "../../../api/mongodb";
import { defaultOptions1 } from "../../../config/loading-config.js";
import Lottie from "react-lottie";
import Button from "react-bootstrap/Button";

import * as SurveyCore from "survey-core";
import { FunctionFactory } from "survey-core";
import { UserContext } from "../../../api/UserProvider.js";
// import * as SurveyReact from "survey-react-ui";
window["$"] = window["jQuery"] = $;

StylesManager.applyTheme("modern");
require("jquery-ui-dist/jquery-ui.js");
widgets.jqueryuidatepicker(SurveyCore);
widgets.inputmask(SurveyCore);

const EditClient = (location) => {
  const [isLoading, setIsLoading] = useState(true);
  const [clientSurveyModel, setClientSurveyModel] = useState(new Model({}));
  const userId = useContext(UserContext).id;

  const { id } = useParams();

  useEffect(() => {
    createSurvey();
  }, []);

  const createSurvey = () => {
    db.get("/api/newClientTemplates", {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then((clientTemplateResponse) => {
      db.get(`/api/clients/${id}`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      }).then((clientResponse) => {
        let survey;
        survey = new Model(clientTemplateResponse.data[0].surveyTemplate);

        survey.data = clientResponse.data.formData;

        survey.completeText = "Save";
        survey.completedHtml = "Changes saved!";

        survey.onComplete.add(
          (sender, options) => {
            const payload = {
              formData: survey.data,
              safeApId: userId,
            };
            // payload["safeApId"] = userId;

            db.put(`/api/clients/${id}`, payload, {
              headers: {
                Authorization: `${localStorage.getItem("token")}`,
              },
            }).then(
              (clientResponse) => {},
              (error) => {}
            );
          },
          (error) => {}
        );

        setIsLoading(false);
        setClientSurveyModel(survey);
        // remove clean button
        survey.onUpdateQuestionCssClasses.add(function (sender, options) {
          if (options.question.getType() === "file") {
            options.cssClasses.removeButtonBottom =
              options.cssClasses.removeButton;
          }
        });
      });

      //   setIsLoading(false);
      //   setClientSurveyModel(survey);
      //   // remove clean button
      //   survey.onUpdateQuestionCssClasses.add(function (sender, options) {
      //     if (options.question.getType() === "file") {
      //       options.cssClasses.removeButtonBottom =
      //         options.cssClasses.removeButton;
      //     }
      //   });
    });
  };

  if (isLoading) {
    return <Lottie options={defaultOptions1} height={200} width={200} />;
  }

  return (
    <>
      {/* <div className="create-project-header">
        <div className="buttons-placement-header">
          <Link to={`/clients`}>
            <Button className="survey-back-button">Back</Button>
          </Link>
        </div>
        <h2 className="create-project-title">Create a new client</h2>
      </div>
      <div className="create-project-container">
        <Survey model={clientSurveyModel} />
      </div> */}
      <div className="project-grid">
        <div className="project-grid-header">
          <h1 className="page-title">Edit Client</h1>
          <div className="grid-list-icons">
            <Link to={`/clients/profile/${id}`}>
              <Button className="btn-primary">Back</Button>
            </Link>
          </div>
        </div>
        <div className="create-project-container">
          <Survey model={clientSurveyModel} />
        </div>
      </div>
    </>
  );
};

export default EditClient;
